/**
 * takeaway.js — wirtschaft. am markt
 * ---------------------------------------------------------------------------
 * Opens/closes the take-away popup (snippets/takeaway-popup.liquid),
 * triggered by [data-takeaway-toggle] or links to "#takeaway" (the header
 * pill). Esc and backdrop click close; scroll locking mirrors the mini-cart
 * pattern (Lenis-aware); focus returns to the opener. The <html> class hides
 * Zenchef's floating chip while the popup is open (see takeaway.css).
 *
 * Das Lunch-Popup lief bis 09/2026 nach demselben Muster hier mit. Es ist
 * der Seite /pages/lunch gewichen (sections/lunch.liquid) — der Header-Pill
 * verlinkt sie direkt, auf Mobile wie auf Desktop.
 */

(() => {
  "use strict";

  function lockScroll() {
    if (window.lenis) window.lenis.stop();
    else document.documentElement.style.overflow = "hidden";
  }

  function unlockScroll() {
    if (window.lenis) window.lenis.start();
    else document.documentElement.style.overflow = "";
  }

  function setupPopup(opts) {
    var root = document.querySelector(opts.root);
    if (!root) return;

    var closeBtn = root.querySelector(opts.close);
    var backdrop = root.querySelector(opts.backdrop);
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      root.removeAttribute("hidden");
      document.documentElement.classList.add(opts.htmlClass);
      lockScroll();
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.setAttribute("hidden", "");
      document.documentElement.classList.remove(opts.htmlClass);
      unlockScroll();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function isOpen() {
      return !root.hasAttribute("hidden");
    }

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest(opts.trigger);
      if (trigger) {
        event.preventDefault();
        open();
      }
    });

    if (closeBtn) closeBtn.addEventListener("click", close);
    if (backdrop) backdrop.addEventListener("click", close);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen()) close();
    });
  }

  setupPopup({
    root: "[data-takeaway]",
    trigger: '[data-takeaway-toggle], a[href="#takeaway"], a[href$="#takeaway"]',
    close: "[data-takeaway-close]",
    backdrop: "[data-takeaway-backdrop]",
    htmlClass: "takeaway-is-open",
  });
})();
